/**
 * Copies of GET responses kept on the device, so the app opens with the last known
 * data and stays readable without network. Cleared on logout.
 */
// bumped when a response changes shape: copies saved by an older version are never read
const PREFIX = 'fin.cache.v12:';
// one oversized response must not push everything else out of the ~5 MB quota
const MAX_ENTRY = 512 * 1024;

export const stored = {
  read<T>(path: string): T | undefined {
    try {
      const s = localStorage.getItem(PREFIX + path);
      return s ? (JSON.parse(s) as T) : undefined;
    } catch { return undefined; }
  },
  write(path: string, data: unknown) {
    try {
      const s = JSON.stringify(data);
      if (s.length <= MAX_ENTRY) localStorage.setItem(PREFIX + path, s);
    } catch { /* quota exceeded or storage unavailable: keep working from memory */ }
  },
  clear() {
    try {
      for (const k of Object.keys(localStorage)) if (k.startsWith('fin.cache.')) localStorage.removeItem(k);
    } catch { /* storage unavailable */ }
  },
};
